<template>
  <div>
    <div id="print-report">
      <!-- Print Only -->
      <HeaderPrint />
      <!-- / Print Only -->
      <v-card>
        <div class="pa-2 d-print-none">
          <v-row no-gutters class="align-center">
            <v-col class="pa-2 d-flex">
              <v-btn
                small
                class="px-2 white black--text d-print-none mr-2"
                @click="$printReport()"
              >
                <v-icon small left>mdi-printer</v-icon>
                {{ $t("print") }}
              </v-btn>
            </v-col>

            <v-spacer></v-spacer>

            <v-col cols="12" md="4">
              <v-text-field
                :class="$vuetify.breakpoint.xs ? 'mt-3' : ''"
                v-model="search"
                style="max-width: 600px"
                append-icon="mdi-magnify"
                :label="$t('search')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <v-divider></v-divider>
        <div>
          <v-data-table
            :headers="headers"
            :items="datatableItems"
            :search="search"
            :items-per-page="10"
            class="elevation-1"
            :footer-props="{
              'items-per-page-text': this.$t('rowsPerPage'),
            }"
            :page.sync="currPage"
          >
            <!-- Não Exibe o "No data available" no data table -->
            <template slot="no-data">
              <div></div>
            </template>

            <template v-slot:item.id_promocao="{ item }">
              <v-btn @click="$copy(item.id_promocao)" x-small>
                {{ item.id_promocao }}
              </v-btn>
            </template>

            <template v-slot:item.id_player="{ item }">
              <v-btn @click="$copy(item.id_player)" x-small>
                {{ item.id_player }}
              </v-btn>
            </template>

            <template v-slot:item.entry_id="{ item }">
              <v-btn @click="$copy(item.entry_id)" x-small>
                {{ item.entry_id }}
              </v-btn>
            </template>

            <template v-slot:item.id_afiliado="{ item }">
              <v-btn
                @click="$copy(item.id_afiliado)"
                x-small
                v-if="item.id_afiliado"
              >
                {{ item.id_afiliado }}
              </v-btn>
              <v-icon v-else>
                mdi-dots-horizontal
              </v-icon>
            </template>

            <template v-slot:item.nome_afiliado="{ item }">
              <span v-if="item.nome_afiliado">
                {{ item.nome_afiliado }}
              </span>
              <v-icon v-else>
                mdi-dots-horizontal
              </v-icon>
            </template>

            <template v-slot:item.value="{ item }">
              <div :class="getColor(item.id_operacao == '16')">
                {{ `${$t("labelCurrency")} ${item.value}` }}
              </div>
            </template>

            <template v-slot:item.entry_finalized="{ item }">
              <div class="caption">{{ item.entry_finalized }}</div>
            </template>

            <template v-slot:item.bonus_status="{ item }">
              <v-chip :color="item.bonus_status === '1' ? 'green' : ''">{{
                item.bonus_status === "1" ? $t("active") : $t("bonusCancelled")
              }}</v-chip>
            </template>

            <template v-slot:item.statusUI="{ item }">
              <div v-html="item.statusUI"></div>
            </template>

            <!-- <template v-slot:item.action="{ item }">
              <v-btn-toggle v-if="item.bonus_status === '1'" dense>
                <DialogCancelCasinoBonus :selectedItemBonusID="item.id_bonus" />
              </v-btn-toggle>
            </template> -->

            <template v-slot:item.nome_operacao="{ item }">
              {{ item.nome_operacao }}
            </template>
          </v-data-table>
        </div>
      </v-card>
      <!-- Resume -->
      <div
        class="mt-4"
        v-if="datatableItems != 0 && selectSport.value === 'sports'"
      >
        <v-row>
          <v-col v-if="$vuetify.breakpoint.smAndUp" sm="6" md="8"></v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-card class="pa-3">
              <div class="subtitle-1 mb-2">
                {{ $t("periodSummary") }}
                <v-icon
                  class="float-right mr-3 d-print-none"
                  @click="$copy(resumePrint)"
                >
                  mdi-content-copy
                </v-icon>
                <div class="caption">{{ $store.state.rangeUI }}</div>
              </div>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td class="caption">{{ $t("bonusTotalConcedido") }}</td>
                      <td class="text-right" v-if="loading">
                        <v-icon>mdi-dots-horizontal</v-icon>
                      </td>
                      <td class="text-right orange--text" v-else>
                        {{
                          `${$t("labelCurrency")} ${resume.gainedBonus.toFixed(
                            2
                          ) || 0}`
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="caption">{{ $t("bonusTotalResgatado") }}</td>
                      <td class="text-right" v-if="loading">
                        <v-icon>mdi-dots-horizontal</v-icon>
                      </td>
                      <td class="text-right red--text" v-else>
                        {{
                          `${$t(
                            "labelCurrency"
                          )} ${resume.transferedCredit.toFixed(2) || 0}`
                        }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderPrint from "@/components/common/header-print";
// import CreateCasinoBonus from "./createCasinoBonus";
// import DialogCancelCasinoBonus from "./dialogCancelCasinoBonus";
export default {
  name: "views-backoffice-colab-bonus-listBonusOnline",
  components: {
    HeaderPrint,
    // CreateCasinoBonus,
    // DialogCancelCasinoBonus,
  },
  data: () => ({
    createCasinoBonusDialog: false,
    // Datatable
    search: "",
    datatableItems: [],

    // Resume
    selectedItemBonusID: "",

    resume: {
      gainedBonus: 0,
      transferedCredit: 0,
    },

    currPage: 1,
    loading: false,
  }),

  created() {
    this.$store.commit("setSelectSport", {
      text: this.$t("sports"),
      value: "sports",
    });

    this.$store.commit("GroupExport", this.selectSport.value === "sports");
    // this.$store.commit(
    //   "SelectTypeBankStatement",
    //   this.selectSport.value === "casino"
    // );
    this.$store.commit("BonusReportType", this.selectSport.value === "sports");
  },

  computed: {
    casino() {
      return this.$store.state.operator.casino != "0";
    },
    // statusBonus() {
    //   return this.$store.state.filters.selectTypeBankStatement.value;
    // },
    headers() {
      if (this.selectSport.value === "sports") {
        return [
          {
            text: this.$t("entryId"),
            value: "entry_id",
          },
          {
            text: this.$t("promotionId"),
            value: "id_promocao",
          },
          {
            text: this.$t("userID"),
            value: "id_player",
          },
          {
            text: this.$t("userName"),
            value: "name_player",
          },
          {
            text: this.$t("affiliateId"),
            value: "id_afiliado",
          },
          {
            text: this.$t("affiliateName"),
            value: "nome_afiliado",
          },
          {
            text: this.$t("value"),
            value: "value",
          },
          {
            text: this.$t("date"),
            value: "entry_date",
          },
          {
            text: this.$t("operation"),
            value: "nome_operacao",
          },
        ];
      }

      return [
        {
          text: this.$t("bonusID"),
          value: "id_bonus",
        },
        {
          text: this.$t("name"),
          value: "name_player",
        },
        {
          text: this.$t("userID"),
          value: "id_player",
        },
        {
          text: this.$t("game"),
          value: "game_name",
        },
        { text: "Rounds", value: "qtd_rounds" },
        {
          text: this.$t("status"),
          value: "bonus_status",
          sortable: false,
        },
        // {
        //   text: this.$t("actions"),
        //   value: "action",
        // },
      ];
    },
    rangeDate() {
      return this.$store.state.range.date;
    },
    bonusReportType() {
      return this.$store.state.filters.bonusReportType.value;
    },
    selectSport() {
      return this.$store.state.filters.selectSport;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    export() {
      return this.$store.state.filters.groupExport.value;
    },
    createBonusDialog() {
      return this.$store.state.showDialog;
    },
  },
  watch: {
    saveFilters(val) {
      val && this.submit();
    },
    // Dá refresh nos dados quando dialog de criar bônus é fechado
    createBonusDialog(newValue, oldValue) {
      !newValue && oldValue && this.listBonusOnline();
    },
    selectSport(val) {
      this.datatableItems = [];
      this.$store.commit("GroupExport", val.value === "sports");
      //   this.$store.commit("SelectTypeBankStatement", val.value === "casino");
      this.$store.commit("BonusReportType", val.value === "sports");
    },
  },
  methods: {
    submit() {
      if (this.selectSport.value === "sports") {
        this.listBonusOnline();
      } else {
        this.listFreeRounds();
      }
    },
    async listBonusOnline() {
      const body = {
        ...this.rangeDate,
        status: this.bonusReportType,
        export: this.export,
      };

      const endpoint = "/colab/bankOnline/listBonus";

      if (this.export) {
        await this.$request.exportDoc(
          endpoint,
          body,
          this.export,
          this.rangeDate
        );

        return;
      }

      this.loading = true;
      this.resume.transferedCredit = 0;
      this.resume.gainedBonus = 0;

      this.$axios
        .post(endpoint, this.$formdata(body))
        .then((response) => {
          this.datatableItems = response.data.dados;
          this.datatableItemsTreatment();
          this.buildResumeData();
        })
        .catch(() => {
          this.datatableItems = [];
        })
        .finally(() => {
          this.currPage = 1;
          this.loading = false;
        });
    },
    async listFreeRounds() {
      const endpoint = "/colab/cassino/bonus/list";

      const body = {
        ...this.rangeDate,
        // status: this.statusBonus,
      };

      this.$axios
        .post(endpoint, this.$formdata(body))
        .then((res) => {
          this.datatableItems = res.data.dados;
          this.datatableItemsTreatment();
          //   this.buildResumeData();
        })
        .catch(() => {
          this.datatableItems = [];
        })
        .finally(() => {
          this.currPage = 1;
          this.loading = false;
        });
    },
    buildResumeData() {
      this.datatableItems.forEach((item) => {
        const isTransfer = item.id_operacao == "16";

        if (isTransfer) {
          this.resume.transferedCredit += Number(item.value);
        } else {
          this.resume.gainedBonus += Number(item.value);
        }
      });

      this.resumePrint = `<table>
        <tr>${this.resume.gainedBonus
          .toFixed(2)
          .toString()
          .replace(".", ",")}</tr>
        <tr>${this.resume.transferedCredit
          .toFixed(2)
          .toString()
          .replace(".", ",")}</tr>
     </table>`;
    },

    datatableItemsTreatment() {
      this.datatableItems.forEach((item) => {
        item.entry_date = item.entry_date
          ? new Date(item.entry_date.replace(" ", "T")).toLocaleString()
          : item.entry_date;
      });
    },

    getColor(isTransfer) {
      if (isTransfer) {
        return "red--text";
      } else {
        return "orange--text darken-4";
      }
    },
  },
};
</script>
